<template>
  <div class="ac-card-content">
    <div class="ac-header-container">
      <div class="ac-header">
        Reverifying Hub 
      </div>
      <button 
        type="button" 
        class="ac-close-button" 
        @click="toggleActionModal(false)"
      >
        <img 
          src="@shared/assets/img/general/x-black.png"
          alt="x" 
          class="ac-close" 
        >
      </button>
    </div>
    <div class="ac-body-container">
      <div class="ac-body-header">
        Verification may take several minutes to complete.
      </div>
      <div class="ac-body-header">
        Close and check later.
      </div>
    </div>
  </div>
</template>

<script>
import customerDetailMixin from '@shared/mixins/customerDetailMixin';

export default {
  name: 'TakeAFewCheckLater',
  mixins: [customerDetailMixin],
}
</script>
